<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-pdt">
    <header class="tpl-pdt__top">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-pdt__logo" />
      <h1 class="tpl-pdt__hero-title">{{ quiz.title }}</h1>
      <p v-if="quiz.sub_title" class="tpl-pdt__hero-sub">{{ quiz.sub_title }}</p>
    </header>

    <main class="tpl-pdt__dark">
      <div class="tpl-pdt__card">
        <div class="tpl-pdt__card-accent"></div>
        <slot />
      </div>

      <p v-if="quiz.disclaimer" class="tpl-pdt__urgency">{{ quiz.disclaimer }}</p>
      <p class="tpl-pdt__legal">
        <template v-if="quiz.legal_name"><strong>{{ quiz.legal_name }}</strong>
          <template v-if="quiz.legal_id"> - {{ quiz.legal_id }}</template></template>
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank" class="tpl-pdt__privacy">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
      </p>
    </main>
  </div>
</template>
